// @flow
export const ROUTE = 'checkout/review/ROUTE';
export const route = () => ({ type: ROUTE });
